module.exports = __webpack_public_path__ + "img/home.c370391d.jpg";